import React from 'react'
import { Footer, FooterButton, Widget } from '../../../../../../shared/chart/widget'
import { IconSave } from '../../../../../../shared/icon/icon'
import { useRouteMatch } from 'react-router-dom'

export const SaveSystem = ({ nodeID, showConfigButton }) => {
  const { url } = useRouteMatch()

  // const apiListGraphCustomCourse = useApiListGraphCustomCourse()

  // useLoad(() => apiListGraphCustomCourse.get(`${nodeID}/node`), [nodeID])

  // const chartData = useMemo(
  //   () => {
  //     if (!apiListGraphCustomCourse.items.length) {
  //       return { labels: [], data: undefined, value: 0 }
  //     }

  //     let value = apiListGraphCustomCourse.items.reduce((a, i) => a + i.count, 0)
  //     let sorted = apiListGraphCustomCourse.items.sort((a, b) => a.topicAnalytic.localeCompare(b.topicAnalytic))
  //     const labels = sorted.map(i => i.topicAnalytic)
  //     const data = sorted.map(i => i.count)

  //     const dataSet = {
  //       data: data,
  //       borderColor: chartColorMain,
  //       backgroundColor: chartColorMain
  //     }

  //     return { labels: labels, data: dataSet, value: value }
  //   },
  //   [apiListGraphCustomCourse.items]
  // )

  return (
    <Widget
      header={<SaveStoreHeader Icon={IconSave} text="Save System" />}
      // body={<ChartBar labels={chartData.labels} data={chartData.data} displayY />}
      footer={
        <React.Fragment>
          <Footer>
            <FooterButton text="Snapshots" to={`${url}/save-snapshot`} />
            <FooterButton text="Configure" to={`${url}/save-configure`} />
          </Footer>
        </React.Fragment>
      }
    />
  )
}

export const SaveStoreHeader = ({ Icon, text }) => {
  return (
    <div className="d-flex">
      <div className="mx-1">
        {Icon && <Icon size="2x" />}
      </div>
      <div className="text-nowrap text-truncate mx-1 fs-3">
        {text}
      </div>
    </div>
  )
}
